import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_INSTAGRAM_SUCCESS,
  DELETE_INSTAGRAM_SUCCESS,
  GET_INSTAGRAM_FAIL,
  GET_INSTAGRAM_SUCCESS,
  UPDATE_INSTAGRAM_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  instagram: [],
  defective: [],
  exports: [],
  error: {},
};

const INSTAGRAM = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INSTAGRAM_SUCCESS:
      return {
        ...state,
        instagram: action.payload.instagram,
        defective: action.payload.defective,
      };

    case GET_INSTAGRAM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_INSTAGRAM_SUCCESS:
      return {
        ...state,
        instagram: [...state.instagram, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_INSTAGRAM_SUCCESS:
      return {
        ...state,
        instagram: state.instagram.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_INSTAGRAM_SUCCESS:
      return {
        ...state,
        instagram: state.instagram.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default INSTAGRAM;
